import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { CalculationResponse } from "src/app/model/calculation/trial-lens.model";
import { RangeFeature } from "src/app/model/catalog/catalog.model";
import { LensSide } from "src/app/model/configuration/configuration";
import { FeatureValues, LensOrderItem } from "src/app/model/order/order";
import { GlobalStorageService } from "src/app/service-utils/global-storage.service";
import { i18nService } from "src/app/service-utils/i18n.service";
import { CatalogService } from "src/app/utils/catalog.service";
import { NewOrderStoreService } from "../../new-order-store-service.service";

@Component({
  selector: 'app-calculation',
  templateUrl: './calculation.component.html',
  styleUrls: ['./calculation.component.scss']
})
export class CalculationComponent implements OnChanges {

  @Input() side: LensSide;
  @Input() data: CalculationResponse;

  form: FormGroup;
  features: FeatureValues = {};
  additionalOptions: any;
  childPrismType: Array<any> = [];
  copyTrialLens: LensOrderItem;

  constructor(private formBuilder: FormBuilder,
              private i18nService: i18nService,
              private newOrderStoreService: NewOrderStoreService,
              private catalog: CatalogService,
              private globalStorageService: GlobalStorageService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.additionalOptions = undefined;
    if(this.data) {
      this.features = this.data.features;
      if(this.data.hasOwnProperty('optional') && this.data.optional !== "null") {
        this.additionalOptions = JSON.parse(this.data.optional);
        this.additionalOptions = this.additionalOptions[0].Prisma;
      }
      this.initLensDetailsForm();
    }
  }

  initLensDetailsForm() {
    let lensDetailsConfig = {};

    Object.keys(this.features).forEach(key => {

      lensDetailsConfig[key] = this.i18nService.replaceFromDotToComma(
        this.i18nService.formatIfNumber(this.features[key], this.globalStorageService.decimalFormats.find(feature => feature.featureName === key)?.decimalFormat)
      );
    });

    if(this.additionalOptions){
      this.childPrismType = [];
      lensDetailsConfig['additionalOptions'] = 'prisma';
      lensDetailsConfig['PrismType'] = '';
      lensDetailsConfig['Prism'] = '';

      Object.keys(this.additionalOptions[0]).forEach(key => {
        let value = this.additionalOptions[0][key];
        if(typeof value === 'object') {
          this.childPrismType.push(value[0].PrismType[0].Value.toString());
          //this.childPrismType[0] = value[0].PrismType[0].Value.toString();
        }
      });

    }

    this.form = this.formBuilder.group(lensDetailsConfig);
    if (this.additionalOptions) {
      this.form.controls['PrismType'].valueChanges.subscribe(() => {
        this.getPrismDefaultValue();
      });
      if (this.form.get('PrismType').value && this.additionalOptions[0].Defaultvalue) {
        this.form.controls['PrismType'].setValue(this.additionalOptions[0].Defaultvalue.toString());
      }
    }
  }

  getPrismDefaultValue(): any {
    if(this.form.get('PrismType').value && this.additionalOptions[0]) {
      let keyChildPrism = this.form.get('PrismType').value === 'classic' ? 'classic' : 'lenticular';
      this.form.controls['Prism'].setValue(this.additionalOptions[0][keyChildPrism][0].Prism[0].Defaultvalue);
      this.setValueWithFormat('Prism');
    }
  }

  getTranslation(key: string): Observable<string> {
    return this.catalog.getFeatureTranslation(key);
  }

  getHintTranslation(feature: RangeFeature): Observable<string> {
    return this.catalog.getFeatureHintTranslation(feature.name);
  }

  getHintByName(name: string): Observable<string> {
    return this.catalog.getFeatureHintTranslation(name);
  }

  setValueWithFormat(featureName: string) {
    if(this.form.controls[featureName] && this.form.controls[featureName].value) {
      this.form.controls[featureName].setValue(
        this.i18nService.replaceFromDotToComma(
          this.i18nService.formatIfNumber(this.form.controls[featureName].value, this.globalStorageService.decimalFormats.find(feature => feature.featureName === featureName)?.decimalFormat)
        )
      );
    }
  }

  isEnabled(featureName: string): boolean {
    let flag: boolean = false;
    Object.entries(this.features).forEach( ([key]) => {
        if (key.valueOf() == featureName){
          flag = true;
        }
      }
    );
    return flag;
  }
}
